import defaultImg from '../../../assets/images/default.avif';
import { useState } from 'react';
interface IProps {
  readonly url: string;
  readonly className: string;
}
export const ImgComponent = (props: IProps) => {
  const [imgSrc, setImgSrc] = useState<string>(props.url);
  return (
    <img
      src={imgSrc}
      onError={() => setImgSrc(defaultImg)}
      className={props.className}
    />
  );
};
